import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { PopupDismissal } from '../models/popup-dialog';

interface PopupPreference {
  never?: boolean;
  remindAfter?: number;
}

@Injectable({ providedIn: 'root' })
export class PopupPreferencesService {
  private readonly fallback = new Map<string, PopupPreference>();

  private key(userid: string, dialogid: string): string {
    return `popupDialog:${encodeURIComponent(environment.apiBaseUrl)}:${userid}:${dialogid}`;
  }

  isDismissed(userid: string, dialogid: string): boolean {
    const key = this.key(userid, dialogid);
    let preference = this.fallback.get(key);
    try {
      const saved = localStorage.getItem(key);
      if (saved && !preference) preference = JSON.parse(saved);
    } catch (_) {}
    return (
      preference?.never === true ||
      (typeof preference?.remindAfter === 'number' &&
        Number.isFinite(preference.remindAfter) &&
        preference.remindAfter > Date.now())
    );
  }

  dismiss(userid: string, dialogid: string, choice: PopupDismissal): void {
    const key = this.key(userid, dialogid);
    const preference: PopupPreference =
      choice === 'dont-show-again' ? { never: true } : { remindAfter: Date.now() + 7 * 24 * 60 * 60 * 1000 };
    this.fallback.set(key, preference);
    try {
      localStorage.setItem(key, JSON.stringify(preference));
      this.fallback.delete(key);
    } catch (_) {}
  }
}
